import app from '../../app';
import template from './heroList.html';

app.component('heroList', { 
    template: template
});